module.exports = __webpack_public_path__ + "img/1802499-21-3.03968144.png";